import { Pipe, PipeTransform } from '@angular/core';
import { AsphaltPerformerPlanningEntry } from '../services/executor-planning.service';
import { DuplicateEntry } from './duplicate-entry-select-dialog.component';

@Pipe({
    name: 'isAsphaltEntry',
    standalone: false,
})
export class IsAsphaltEntryPipe implements PipeTransform {
    transform(entry: DuplicateEntry | null): entry is AsphaltPerformerPlanningEntry {
        return entry !== null && !('id' in entry);
    }
}
